import { getBearerToken } from "../../../../api/postCall/bearerToken";
import {
  searchForMedicalPaOrdersFromPostgres,
  SearchForMedicalPaOrdersFromPostgresParams,
} from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { PostgresResponseForMedicalPaOrders } from "../../../../data-model/postgresResponseForMedicalPaOrders";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { MyMedicalPaOrdersState } from "../hooks/useMyPaOrdersTableData";
import { generateMyMedicalPaOrdersTableDataFromAlgoliaRecords } from "../utils/generateTableDataFromAlgoliaRecords";

/**
 * Fetches My PA Orders from Postgres using the given search payload, then updates
 * the orders state and table data. Resets pagination on completion.
 *
 * @param payload - Search parameters for the Postgres query
 * @param authStatusOptions - Available auth status options for badge rendering
 * @param setMyMedicalPaOrdersState - State setter for the orders loading/data/error state
 * @param setTableData - State setter for the transformed table row data
 * @param setPaginationResetCount - Incremented to signal a pagination reset
 */
export const makePostCallForMyPaOrders = async (
  payload: SearchForMedicalPaOrdersFromPostgresParams,
  authStatusOptions: AuthStatusOptionModel[],
  setMyMedicalPaOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
) => {
  setMyMedicalPaOrdersState((prev) => ({ ...prev, loading: true }));
  try {
    await getBearerToken();
    const response = await searchForMedicalPaOrdersFromPostgres(payload);
    const data = JSON.parse(response) as PostgresResponseForMedicalPaOrders;
    setMyMedicalPaOrdersState((prev) => ({
      ...prev,
      data: data,
    }));
    setTableData(
      generateMyMedicalPaOrdersTableDataFromAlgoliaRecords(
        data.hits ?? [],
        authStatusOptions,
      ),
    );
  } catch (error) {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, error: error as string }));
  } finally {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, loading: false }));
    setPaginationResetCount((prev) => prev + 1);
  }
};
